import { useEffect } from 'react';
import { dialogPageSpinner } from '../dialog';

export const useClosePageSpinner = () => {
  useEffect(() => {
    dialogPageSpinner.hide();
  }, []);
};
